import { useSelector } from 'react-redux'
import { I18n } from 'react-redux-i18n'

export const UseI18n = (data, options) => {
  useSelector((state) => state.i18n)

  return typeof data === 'string' ? I18n.t(data, options) : ''
}
